import { observable, action, runInAction, computed } from 'mobx';
import BasePaginationStore from '@store/Common/BasePaginationStore';
import ExportData from '@store/Base/ExportData';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import {message} from "antd";

class Item {
  constructor(data) {
    this.init(data);
  }

  @action
  init(data) {
    for(let attr in data) {
      this[attr] = data[attr];
    }
  }

  @observable
  id;

  /**
   * 方案号
   */
  @observable
  number;

  /**
   * 投注金额
   */
  @observable
  amount;

  @observable
  is_add;

  /**
   * 是否合买
   */
  @observable
  is_community;

  @observable
  is_copy;

  @observable
  is_daigou;

  @observable
  is_optimization;

  /**
   * 是否追号
   */
  @observable
  is_zhuihao;

  /**
   * 订单号
   */
  @observable
  order_id;

  /**
   * 玩法类型
   */
  @observable
  play_type;

  /**
   * 开奖结果
   */
  @observable
  result;

  /**
   * 出票结果
   */
  @observable
  status;

  /**
   * 期号
   */
  @observable
  term_no;

  /**
   * 投注时间
   */
  @observable
  time;

  /**
   * 彩票类型
   */
  @observable
  type;

  /**
   * 中奖金额
   */
  @observable
  win_tax_money;

}

class PaginationStore extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 */
class FilterStore {
  @observable
  name;

  @observable
  cellphone;

  @action
  setAttr(attrs) {
    for(let attr in attrs) {
      this[attr] = attrs[attr]
    }
  }

  getAttr() {
    return {
      name: this.name,
      cellphone: this.cellphone
    }
  }

  @action
  resetAttr() {
    this.name = '';
    this.cellphone = '';
  }
}

let filter_store = new FilterStore();

class ItemStore {

  constructor(pagination) {
    this.init(pagination);
  }

  @action
  init(pagination){
    this.pagination_store = pagination;
  }

  @observable
  item_map = new Map();

  @observable
  pagination_store;

  /**
   * 控制编辑 modal 是否显示
   */
  @observable
  is_modal_show = false;

  @observable
  user_id;

  @observable
  pet_name;

  @observable
  nick_name;

  @observable
  balance;

  @observable
  user_num;

  /**
   * 打开 modal 显示
   */
  @action
  async openModal(item) {
    this.user_id = item.id;//44430172;
    this.pet_name = item.pet_name;
    this.nick_name = item.nick_name;
    this.balance = item.balance;
    this.user_num = item.user_num;

    await this.searchByFilter();
    runInAction(() => {
      this.is_modal_show = true;
    });
  }

  @action
  updateRecord(item){
    this.user_id = item.id;//44430172;
    this.pet_name = item.pet_name;
    this.nick_name = item.nick_name;
    this.balance = item.balance;
    this.user_num = item.user_num;
  }

  @action
  updateRecord(item){
    this.user_id = item.id;//44430172;
    this.pet_name = item.pet_name;
    this.nick_name = item.nick_name;
    this.balance = item.balance;
    this.user_num = item.user_num;
  }

  /**
   * 关闭 modal 显示
   */
  @action
  closeModal() {
    this.user_id = "";
    this.pet_name = "";
    this.nick_name = "";
    this.balance = "";
    this.user_num = "";

    this.is_modal_show = false;

    this.item_map.clear();

    this.pagination_store.clear();

    filter_store.resetAttr();
  }

  /**
   * item 数组列表
   */
  @computed
  get item_array() {
    let res = [];
    this.item_map.forEach((values, key) => {
      res.push(values);
    });
    return res;
  }

  /**
   * 根据条件搜索item
   * @param {*} page_opts
   */
  async searchByFilter(page_opts){
    let page_option = {
      page: this.pagination_store.page_cur,
      page_size: this.pagination_store.page_size,
      id: this.user_id,
      ...filter_store.getAttr(),
      ...page_opts
    }
    let res = await this.getOrderList(page_option);
    return res;
  }

  /**
   * 获取item 列表
   */
  async getOrderList(page_option = {}) {
    let url = fetchUrl.admin.orderList;
    let res = await service.fetchData({
      path: url,
      params: {
        ...page_option
      }
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        runInAction(() => {
          // console.log(res);
          this.item_map.clear();
          res.data.data.forEach((item, index) => {
            item.id=item.order_id;
            this.item_map.set(item.id, new Item(item));
          });
          this.pagination_store.setAttr(res.data.page);
        })
      },
      fail_handle: (res) => {
        message.error(res.error.error_data,3);
        this.pagination_store.clear();
        filter_store.resetAttr();
        this.item_map.clear();
      }
    })
    return res;
  }
}

let pagination_store = new PaginationStore();
let item_store = new ItemStore(pagination_store);

export {
  pagination_store,
  filter_store
}

export default item_store;



// WEBPACK FOOTER //
// ./src/Store/User/UserList/UserBetRecordStore.js